
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { TagInterface } from '@/services/QC-V2/tag/interfaces';
import {
  ProfileMapInterface,
  ReviewCommentCreateInterface,
} from '@/services/QC-V2/chat/interfaces';

interface ProfilesInterface {
  id: string,
  name: string,
}

export interface FeedbackDialogDataInterface {
  user: ProfilesInterface;
  scores: string[];
  tags: TagInterface[];
  comments: ReviewCommentCreateInterface[];
  usersMap: ProfileMapInterface;
  reviewIndex?: number
}

@Component({
  mixins: [
    Themeable,
  ],
})
export default class FeedbackDialog extends Vue {
  @Prop() private data!: FeedbackDialogDataInterface;
  private loading: boolean = false;
  private visible: boolean = true;

  private async createFeedback(): Promise<void> {
    this.$emit('create-feedback', this.data.reviewIndex);
    this.destroyComponent();
  }

  private destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
